import type { SVGProps } from "react";
import type { FC } from 'react';
import styled from 'styled-components';
import { iconSizeMap } from '../utils/size-map';
import type { IconSize, TokenSizeProps } from '../utils/type';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<TokenSizeProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 6 6 18M6 6l12 12" /></svg>;
const Wrapper = styled.span<{
  $size?: IconSize;
}>`
  width: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  height: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  display: inline-block;
  vertical-align: middle;
`;
const SvgClose = ({
  $size,
  ...rest
}: TokenSizeProps) => <Wrapper $size={$size} className="mnd-icon"><SvgBase {...rest} /></Wrapper>;
export default SvgClose;